import { CSSProperties } from 'react';

export const FADE_AFTER_MS = 1250;

export type CursorInfo = {
  id: string;
  name: string;
  color: string;
};

export function CursorOverlay({
  cursors,
  registerElement,
}: {
  cursors: CursorInfo[];
  registerElement: (id: string, node: HTMLDivElement | null) => void;
}) {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute top-0 left-0 z-50 h-0 w-0"
      style={
        {
          '--cursor-fade-duration': `${FADE_AFTER_MS}ms`,
        } as CSSProperties
      }
    >
      {cursors.map((cursor) => (
        <div
          key={cursor.id}
          ref={(node) => registerElement(cursor.id, node)}
          className="animate-cursor-fade absolute top-0 left-0"
          style={{ willChange: 'transform' }}
        >
          <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
            <path
              d="M1 1L1 18.1L6 11.9L13.9 12.2Z"
              fill={cursor.color}
              stroke="white"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>

          <span
            className="ml-4 rounded px-1.5 py-0.5 text-xs whitespace-nowrap text-white shadow"
            style={{ backgroundColor: cursor.color }}
          >
            {cursor.name}
          </span>
        </div>
      ))}
    </div>
  );
}
